import React, { Component } from 'react'
global.isclient && require('./rxModalMouseRightChat.css')

class RxModalMouseRightChat extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {

        }
    }
    render() {
        return (
            <div className='zmodal'>
            </div>
        )
    }
}
export default RxModalMouseRightChat
